import React from "react";

export default function Challenges() {
  return (
    <div>
      <h4 className="pages-h4">Challenges</h4>
    </div>
  );
}
